// Single source of truth for listing-status display labels — the filter dropdown,
// the account card and the accounts table all read these so the wording stays in
// sync. Stored value is the raw enum ("listed" / "unlisted"); null = not set.
export const LISTING_STATUS_LABELS: Record<string, string> = {
  listed: "Publicly listed",
  unlisted: "Private",
};
